<template>
  <div>
    <div class="view-container">
      <vue-portal to="hrsys-navbar-actions">
        <div class="flex">
          <base-header-title :title="$t('modules.notifications')"/>
          <vx-tooltip :text="$t('notifications.markAllAsRead')" class="ml-2" position="bottom">
            <base-button @click="markAllAsRead" class="self-end px-3" icon="eye"/>
          </vx-tooltip>
        </div>
      </vue-portal>

      <base-loader :loading="loading">
        <div class="flex mb-5">
          <base-input :label="$t('labels.search')" class="flex-1" v-model="queryParams.search"/>
          <base-button @click="search" class="self-end px-4 ml-2" icon="search"/>
        </div>
        <notifications-table :header="tableHeader" :notifications="list" @notificationClicked="goTo"/>
        <pagination :pagination="pagination" @input="changePage" v-if="pagination.total"/>
      </base-loader>
    </div>
  </div>
</template>

<script>
  import NotificationsTable from '../../components/notifications/NotificationsTable'
  import Pagination from '../../components/Pagination'
  import Notifications from '../../services/Notifications'

  export default {
    name: 'Notifications',
    components: {
      NotificationsTable,
      Pagination
    },
    data: () => ({
      list: [],
      pagination: {},
      importError: {
        message: '',
        errors: []
      },
      queryParams: {
        page: 1,
      },
      loading: false
    }),
    methods: {
      goTo (notification) {
        if (!notification.is_read) {
          notification.is_read = true;
          this.$store.dispatch('markNotificationAsRead', notification);
        }
        Notifications.manageRedirection(notification, this);
      },
      markAllAsRead () {
        this.$vs.dialog({
          type: 'confirm',
          color: 'primary',
          title: this.$t('notifications.markAllAsReadConfirmTitle'),
          text: this.$t('notifications.markAllAsReadConfirmText'),
          accept: () => {
            this.list = this.list.map(n => {
              n.is_read = true;
              return n;
            });
            this.$store.dispatch('markAllNotificationsAsRead');
          }
        });
      },
      changePage (newPage) {
        this.queryParams.page = newPage;
        this.$router.push({query: this.queryParams}).catch(() => {
        })
        this.getNotifications()
      },
      getNotifications () {
        this.loading = true;
        const vm = this;
        Notifications.list(this.queryParams).then(response => {
          vm.$router.push({query: this.queryParams}).catch(() => {
          });
          this.list = response.data
          this.pagination = response.meta.pagination
        }).finally(() => this.loading = false)
      },
      search () {
        this.$router.push({query: this.queryParams}).catch(() => {
        })
        this.queryParams.page = 1
        this.getNotifications()
      },
      getUrlParams () {
        let vm = this;
        if (this.$route.query.page) {
          vm.queryParams = Object.assign({}, vm.$route.query);
        }
      }
    },
    computed: {
      tableHeader () {
        return ([
          this.$t('notifications.table.title'),
          this.$t('notifications.table.date'),
          this.$t('notifications.table.actions'),
        ])
      }
    },
    created () {
      this.getUrlParams();
      this.getNotifications();
    },
  }
</script>

<style scoped>

</style>
